import { Data, TransformsList } from 'cio/utils/analytics/transforms';
import { EmailEditor } from 'cio/services/editor';

import { EditorNameMap } from 'cio/services/editor';
import NewsletterModel from 'cio/models/newsletter';
import CampaignModel from 'cio/models/campaign';
import TransactionalMessageModel from 'cio/models/transactional-message';
import getComposerMessageTypeName from 'cio/utils/analytics/composer-message-type';

type TranslationData = Data & {
  editor: EmailEditor;
  languageCount: number;
};

function getBaseData(data: TranslationData) {
  let baseData: Data;

  if (data.model instanceof NewsletterModel) {
    baseData = getNewsletterData(data);
  } else if (data.model instanceof CampaignModel) {
    baseData = getCampaignData(data);
  } else if (data.model instanceof TransactionalMessageModel) {
    baseData = getTransactionalData(data);
  } else {
    return {};
  }

  return {
    ...baseData,
    'Builder Type': EditorNameMap[data.editor],
  };
}

function getTransactionalData(data: TranslationData) {
  return {
    'Transactional ID': data.model?.id,
    'Transactional Content ID': data.template?.id,
    'Newsletter Name': data.model?.name,
    'Message Type': 'email',
  };
}

function getNewsletterData(data: TranslationData) {
  return {
    'Newsletter ID': data.model?.id,
    'Newsletter Content ID': data.template?.id,
    'Newsletter Name': data.model?.name,
    'Message Type': getComposerMessageTypeName(data.model?.channel),
  };
}

function getCampaignData(data: TranslationData) {
  return {
    'Campaign ID': data.model?.id,
    'Campaign Action ID': data.action?.id,
    'Message Type': getComposerMessageTypeName(data.action?.type),
  };
}

function getLanguageData(data: TranslationData) {
  return {
    ...getBaseData(data),
    'Language Count': data.languageCount,
  };
}

const Transforms: TransformsList = {
  baseData(data: TranslationData) {
    return getBaseData(data);
  },
  translationData(data: TranslationData) {
    return getLanguageData(data);
  },
  deleteLanguageClicked(data: TranslationData & { languageAttribute: string; language: string }) {
    let transformed = getLanguageData(data);

    (transformed as Record<string, any>)['Language Attribute'] = data.languageAttribute;
    (transformed as Record<string, any>)['Language Deleted'] = data.language;

    return transformed;
  },
  translationDataWithLanguageAttribute(data: TranslationData & { languageAttribute: string }) {
    let transformed = getLanguageData(data);

    (transformed as Record<string, any>)['Language Attribute'] = data.languageAttribute;

    return transformed;
  },
  tipLinkClicked(data: Data & { languageAttribute: string; link: string }) {
    return {
      'Language Attribute': data.languageAttribute,
      Link: data.link,
    };
  },
  tabClicked(data: TranslationData & { languageAttribute: string; language: string }) {
    let transformed = getLanguageData(data);

    (transformed as Record<string, any>)['Visible Composer Windows'] = data.visibleComposerWindows;

    return transformed;
  },
};

export default Transforms;
